export default "__VITE_ASSET__M9E5l5YM__ 778w";